import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { attemptTokenRefresh, createApiErrorSimple, createAuthHeaders, extractUrl, getTimeout, shouldAttemptRefresh, } from '../api/authUtils';
import { config } from '../config';
import { ENABLED_FEATURE_HEADER, getEnabledFeature } from '../developerSettings';
const API_BASE_URL = config.apiZeztraBffUrl;
const DEFAULT_TIMEOUT = 30000;
const setZeztraHeaders = (headers) => {
    const account = getSelectedAccountInfo();
    const entityType = account?.entityType;
    const entityId = account?.entityId;
    const partyId = account?.targetId;
    if (entityId && partyId) {
        headers.set('party-id', partyId);
        headers.set('entity-id', entityId);
        headers.set('entity-type', entityType || '');
        headers.set('person-id', entityId);
    }
};
const setAuthorizationHeader = (headers, state) => {
    const authHeaders = createAuthHeaders(state);
    if (authHeaders.Authorization) {
        headers.set('Authorization', authHeaders.Authorization);
    }
};
const createZeztraBaseQuery = (baseUrl, timeout) => {
    return fetchBaseQuery({
        baseUrl,
        timeout,
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            setAuthorizationHeader(headers, state);
            setZeztraHeaders(headers);
            const enabledFeature = getEnabledFeature();
            if (enabledFeature) {
                headers.set(ENABLED_FEATURE_HEADER, enabledFeature);
            }
            return headers;
        },
    });
};
export const customZeztraBaseQuery = async (args, api, extraOptions) => {
    const url = extractUrl(args);
    const timeout = getTimeout(args, DEFAULT_TIMEOUT);
    const baseQuery = createZeztraBaseQuery(API_BASE_URL, timeout);
    const queryArgs = typeof args === 'string' ? url : { ...args, url };
    const result = await baseQuery(queryArgs, api, extraOptions);
    if (result.error) {
        const fetchError = result.error;
        if (shouldAttemptRefresh(fetchError)) {
            const refreshSuccess = await attemptTokenRefresh(api);
            if (refreshSuccess) {
                const refreshedBaseQuery = createZeztraBaseQuery(API_BASE_URL, timeout);
                return refreshedBaseQuery(queryArgs, api, extraOptions);
            }
        }
        if ('status' in fetchError) {
            return { error: createApiErrorSimple(fetchError) };
        }
    }
    return result;
};
export const zeztraBaseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
        const state = getState();
        setAuthorizationHeader(headers, state);
        setZeztraHeaders(headers);
        const enabledFeature = getEnabledFeature();
        if (enabledFeature) {
            headers.set(ENABLED_FEATURE_HEADER, enabledFeature);
        }
        return headers;
    },
});
export const zeztraApi = createApi({
    reducerPath: 'zeztraApi',
    baseQuery: customZeztraBaseQuery,
    tagTypes: ['configuration', 'billing', 'billingRecurrence', 'sendEmail', 'payer', 'nfse', 'ChargeDetails'],
    endpoints: () => ({}),
});
